// extracted by mini-css-extract-plugin
export default {"detail-row-container":"detailCellRender_detail-row-container__sr-hO","detail-row":"detailCellRender_detail-row__jSOsY","loading-row":"detailCellRender_loading-row__egqmo"};